import { CheckCircle2, Mail, ClipboardList, LifeBuoy } from "lucide-react";

// Landing page after a hosted Scale360 Stripe checkout (success_url). Static on purpose: it must
// render for every paying customer without any lookup, so it never depends on the session id.
export default function Scale360Success() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center px-4">
      <div className="w-full" style={{ background: "#111827" }}>
        <div className="max-w-5xl mx-auto px-4 py-4">
          <img
            src="https://scale360.wibiz.ai/wp-content/uploads/2026/03/scale-logo-1.png"
            alt="Scale360"
            className="h-8 w-auto object-contain"
          />
        </div>
      </div>

      <main className="bg-white rounded-2xl border border-gray-200 shadow-sm p-10 max-w-lg w-full mt-12">
        <div className="flex flex-col items-center text-center gap-3">
          <CheckCircle2 className="w-14 h-14 text-green-500" />
          <h1 className="text-2xl font-bold text-gray-900">Thank you, your Scale360 payment is confirmed</h1>
          <p className="text-gray-600">
            Your subscription is active. Here is what happens next.
          </p>
        </div>

        <ol className="mt-8 space-y-5 text-left">
          <li className="flex gap-3">
            <Mail className="w-5 h-5 mt-0.5 shrink-0" style={{ color: "#E8620A" }} />
            <div>
              <p className="font-semibold text-gray-900">Check your email</p>
              <p className="text-sm text-gray-600">
                We are sending your payment receipt and your onboarding link to the email address you used at checkout.
                If you do not see it within a few minutes, check your spam or promotions folder.
              </p>
            </div>
          </li>
          <li className="flex gap-3">
            <ClipboardList className="w-5 h-5 mt-0.5 shrink-0" style={{ color: "#E8620A" }} />
            <div>
              <p className="font-semibold text-gray-900">Complete your onboarding form</p>
              <p className="text-sm text-gray-600">
                The onboarding link takes you through a short form about your business. Our team uses your answers to
                set up your Scale360 account, so the more detail you give, the faster we can get you live.
              </p>
            </div>
          </li>
          <li className="flex gap-3">
            <LifeBuoy className="w-5 h-5 mt-0.5 shrink-0" style={{ color: "#E8620A" }} />
            <div>
              <p className="font-semibold text-gray-900">We are here if you need us</p>
              <p className="text-sm text-gray-600">
                Questions, or no email yet? Write to{" "}
                <a href="mailto:support@scale360.wibiz.ai" className="font-semibold underline" style={{ color: "#E8620A" }}>
                  support@scale360.wibiz.ai
                </a>{" "}
                and we will help right away.
              </p>
            </div>
          </li>
        </ol>

        <div className="mt-8 text-center">
          <a
            href="https://scale360.wibiz.ai/"
            className="inline-block px-5 py-2.5 rounded-lg text-sm font-semibold text-white"
            style={{ background: "#E8620A" }}
          >
            Back to Scale360
          </a>
        </div>
      </main>
    </div>
  );
}
